import { css } from "./SKT";

export const SKTToolbar = ({ children }) => {
  return (
    <div className={css("btn-toolbar2")} role="toolbar">
      {children}
    </div>
  );
};
